<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
        <div class="col-12">
            <div class="card">
            <div class="card-body">
                <b-button @click="addCategory" variant="primary" class="btn btn-success btn-sm"> <i class="mdi mdi-plus"></i> {{ $t('button.add.text') }}</b-button> 
                <b-button-group>
                    <b-button @click="uploadFormat" variant="outline-secondary" class="btn btn-outline-success rounded btn-sm ml-1"> <i v-if="import_file == ''" class="mdi mdi-upload-multiple mr-1"></i> {{import_file != 0 ? import_file.name : 'Bulk Import'}}</b-button>
                    <b-button v-if="import_file != 0" @click="importNews" variant="success" class="btn btn-success btn-sm">
                        <i v-if="loading" class="mdi mdi-spin mdi-loading"></i>
                        <i v-if="!loading" class="mdi mdi-upload-multiple"></i>
                    </b-button>
                </b-button-group>
                <input name="csv_news" type="file" ref="csv_news" class="d-none ml-1" v-on:change="bulkImport">
                <b-button @click="downloadFormat" title="Format CSV Bulk Import" variant="success" class="btn btn-sm rounded ml-1"> <i class="mdi mdi-arrow-collapse-down mr-1"></i>Format xlsx</b-button>
                <b-button @click="exportNews" variant="primary" class="btn rounded btn-sm ml-1"> <i class="mdi mdi-arrow-collapse-down mr-1"></i>Export News Setting</b-button>
             
                <b-button class="btn btn-sm rounded-xs ml-1" style="border-radius:4%" variant="danger" @click="bulkAction" v-if="selected[0]">{{ $t('button.bulk') }}: {{selected.length}} {{ $t('button.row-data') }}</b-button>
                <!-- {{tableData}} -->
                <b-modal
                    id="modal-add"
                    centered
                    :title="$t('button.add.text')"
                    title-class="font-18"
                    :ok-title="$t('button.save.text')"
                    :cancel-title="$t('button.cancel.text')"
                    @ok="addCategorySave"
                >
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('news.source_name') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('news.source_name')"
                                v-model="form.source_name"
                                :class="{ 'is-invalid': submitted && $v.form.source_name.$error }"
                                />
                                <div v-if="submitted && $v.form.source_name.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.source_name.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                         <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('news.source_domain') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('news.source_domain')"
                                v-model="form.source_domain"
                                :class="{ 'is-invalid': submitted && $v.form.source_domain.$error }"
                                />
                                <div v-if="submitted && $v.form.source_domain.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.source_domain.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom02">{{ $t('news.category') }}</label>
                                <select 
                                class="custom-select" 
                                v-model="form.source_category" 
                                :class="{ 'is-invalid': submitted && $v.form.source_category.$error }">
                                    <option value="Mainstream">Mainstream</option>
                                    <option value="Non Mainstream">Non Mainstream</option>
                                    <option value="Agregator">Agregator</option>
                                </select>
                                <div v-if="submitted && $v.form.source_category.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.source_category.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal>
                <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        {{ $t('all.show') }}&nbsp;&nbsp;
                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;
                    </label> {{ $t('all.entries') }}
                    </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                         {{ $t('all.search') }}:
                        <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('all.search')"
                        class="form-control form-control-sm ml-2"
                        ></b-form-input>
                    </label>
                    </div>
                </div>
                <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                <b-table
                    :items="tableData"
                    :fields="fields"
                    bordered striped
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                >
                 <template #head(bulk) width="4%">
                    <!-- <b-form-checkbox class="text-center mt-0" v-model="selectedAll"/> -->
                        <b-form-checkbox
                            v-model="selectAll" 
                            @change="select"
                            class="text-center mt-0">
                        </b-form-checkbox>
                    </template>
                    <template #cell(bulk)="row" width="4%">
                        <b-form-checkbox class="text-center mt-0" v-model="selected" :value="row.item.id_news_category"/>
                    </template>

                    <template #cell(actions)="row">
                        <b-button class="mr-1 btn-sm" variant="info" @click="editCategory(row.item.id_news_category, row.item.source_name, row.item.source_domain, row.item.source_category)"> 
                            <i class="bx bx-pencil"></i> 
                        </b-button>
                        <b-modal
                            :id="'modal-edit'+row.item.id_news_category"
                            centered
                            :title="$t('button.update.text')"
                            title-class="font-18"
                            :ok-title="$t('button.update.text')"
                            :cancel-title="$t('button.cancel.text')"
                            @ok="updateCategory($event, row.item.id_news_category)"
                        >
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('news.source_name') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('news.source_name')"
                                        v-model="form.source_name"
                                        :class="{ 'is-invalid': submitted && $v.form.source_name.$error }"
                                        />
                                        <div v-if="submitted && $v.form.source_name.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.source_name.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                 <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('news.source_domain') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('news.source_domain')"
                                        v-model="form.source_domain"
                                        :class="{ 'is-invalid': submitted && $v.form.source_domain.$error }"
                                        />
                                        <div v-if="submitted && $v.form.source_domain.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.source_domain.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom02">{{ $t('news.category') }}</label>
                                        <select 
                                        class="custom-select" 
                                        v-model="form.source_category" 
                                        :class="{ 'is-invalid': submitted && $v.form.source_category.$error }">
                                            <option value="Mainstream">Mainstream</option>
                                            <option value="Non Mainstream">Non Mainstream</option>
                                            <option value="Agregator">Agregator</option>
                                        </select>
                                        <div v-if="submitted && $v.form.source_category.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.source_category.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                        <b-button class="mr-0 btn-sm" variant="danger" @click="deleteCategory(row.item.id_news_category)">
                         <i class="bx bx-trash"></i>
                        </b-button>
                    </template>
                </b-table>
                </div>
                <div class="row" v-if="rows > 10">
                    <div class="col-2 col-xl-1">
                        <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                        </div> -->
                        <label class="d-inline-flex align-items-center">
                        Page
                        <b-form-input
                            v-model="currentPage"
                            placeholder="Page"
                            class="form-control w-10 form-control ml-2"
                        ></b-form-input>
                        </label>
                    </div>
                    <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import NewsCategoryService from "@/helpers/newscategory.service"

export default {
    page: {
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            tableData: [],
            title: this.$t('news.news-setting'),
            items: [
                {
                text: this.$t('menuitems.setting.text'),
                href: "#"
                },
                {
                text: this.$t('news.news-setting'),
                active: true
                }
            ],
            selected: [],
            import_file : "",
            loading: false,
		    selectAll: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "total_profile",
            sortDesc: false,
            fields: [
                { key: "no", class: 'text-center', thStyle: { width: "3%" }, label:'No'},
                { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
                { key: "source_name", sortable: true, label: this.$t('news.source_name') },
                { key: "source_domain", sortable: true, label: this.$t('news.source_domain') },
                { key: "source_category", sortable: true, label: this.$t('news.category') },
                { key: 'actions', class: 'text-center', label: this.$t('table.category-profile.th.action') }
            ],
            form: {
                source_name: "",
                source_domain: "",
                source_category: ""
            },
            submitted: false,
        };
    },
    validations: {
        form: {
            source_name: { required },
            source_domain: { required },
            source_category: { required }
        },
    },
    computed: {
        rows() {
        return this.tableData.length;
        }
    },
    methods: {
         select() {
            console.log('selected');
                this.selected = [];
                if (!this.selectAll) {
                    for (let i in this.tableData) {
                        this.selected.push(this.tableData[i].id_news_category);
                    }
                }
        },
        getCategory(){
            NewsCategoryService.list()
            .then(response => {
                this.tableData = []
                response.data.data.forEach((val, index) => {
                    const data = {
                    "no": index+1,
                    "id_news_category" : val.id_news_category,
                    "source_name" : val.source_name,
                    "source_domain" : val.source_domain,
                    "source_category" : val.source_category,
                    }
                    this.tableData.push(data);
                });
            })
            .catch(err => {
                console.log(err);
            });
        },
        addCategorySave(e) {
            this.submitted = true;
            this.$v.$touch();
            if (this.form.source_name == '' ||  this.form.source_domain == ''  || this.form.source_category == '') {
                e.preventDefault();
            }else{
                const data = {
                    'source_name' : this.form.source_name,
                    'source_domain' : this.form.source_domain,
                    'source_category' : this.form.source_category,
                }
                console.log(data);

                NewsCategoryService.create(data)
                .then( response => {
                    this.getCategory();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.$v.$reset();
                    this.resetForm();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        editCategory(id, name, sub, category){
            this.$bvModal.show('modal-edit'+id)
            this.form.source_name = name;
            this.form.source_domain = sub;
            this.form.source_category = category;
        },
         addCategory(){
            this.$bvModal.show('modal-add')
            this.form.source_name = "";
            this.form.source_domain = "";
            this.form.source_category = "";
        },
        updateCategory(e, id){
            this.submitted = true;
            this.$v.$touch();
            if (this.form.source_name == '' || this.form.source_domain == ''  || this.form.source_category == '') {
                e.preventDefault();
            }else{
                const data = {
                    'source_name' : this.form.source_name,
                    'source_domain' : this.form.source_domain,
                    'source_category' : this.form.source_category,
                }

                NewsCategoryService.update(id, data)
                .then( response => {
                    this.getCategory();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.resetForm();
                    this.$v.$reset();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        deleteCategory(id){
            Swal.fire({
                title: this.$t('button.delete.modal.confirmText[0]'),
                text: this.$t('button.delete.modal.confirmText[1]'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: this.$t('button.cancel.text'),
                confirmButtonText: this.$t('button.delete.text')
            }).then((result) => {
                if (result.isConfirmed) {
                    NewsCategoryService.delete(id)
                    .then( response => {
                        this.getCategory();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( err => {
                        console.log(err);
                    });
                }
            });
        },
        bulkAction(){
             Swal.fire({
                  title: this.$t('button.delete.modal.confirmText[0]'),
                  text: this.$t('button.delete.modal.confirmText[1]'),
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: this.$t('button.cancel.text'),
                  confirmButtonText: this.$t('button.delete.text')
              }).then((result) => {
                  if (result.isConfirmed) {
                    var data = this.selected;
                    // console.log(data);
                      NewsCategoryService.deleteBulk(data)
                      .then( response => {
                         this.selected = [];
                          this.getCategory();
                          Swal.fire({
                              position: "top-end",
                              icon: "success",
                              title: response.data.message,
                              showConfirmButton: false,
                              timer: 1500
                          });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
              });
        },

        downloadFormat(){
            NewsCategoryService.format()
            .then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'format_import_news.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            });
        },
        exportNews(){
            console.log('export');
            NewsCategoryService.newsExport()
            .then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'newssetting.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            });
        },
        uploadFormat(){
            this.$refs.csv_news.click();
        },
        bulkImport(){
            this.import_file = this.$refs.csv_news.files[0];
        },
        importNews(){
            this.loading = true;
            let formData = new FormData();
            formData.append('csv_news', this.import_file);

            console.log(formData);
            NewsCategoryService.newsImport(formData)
            .then(response => {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Import Success",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$refs.csv_news.value = '';
                this.import_file = ''
                this.loading = false;
                this.getCategory();
            })
            .catch(e => {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$refs.csv_news.value = '';
                this.loading = false;
                this.getCategory();
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onDelete(id){
            console.log('delete data:', id);
        },
        onView(id){
            console.log('details data:', id);
        },
        resetForm(){
            setTimeout(()=>{
                this.form.source_name = '';
                this.form.source_domain = '';
                this.form.source_category = '';
            }, 2000)
        }
    },
    mounted() {
        this.totalRows = this.items.length;
        this.getCategory();
    },
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
</style>